import { render } from "./CustomPagination.vue?vue&type=template&id=02112bb8&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"

import "./CustomPagination.vue?vue&type=style&index=0&id=02112bb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02112bb8"]])

export default __exports__